import React, { useState } from 'react';
import { cn } from '../lib/utils';
import ChartOfAccountsView from './ChartOfAccountsView';
import TagsView from './TagsView';
import TaxBaseView from './TaxBaseView';
import JournalsSetupView from './JournalsSetupView';

import DefaultAccountsView from './DefaultAccountsView';

interface AccountingConfigurationViewProps {
  orgId: string;
  language: string;
  onNavigate?: (tab: string, id?: string, extra?: any) => void;
  settings?: any;
}

export default function AccountingConfigurationView({ orgId, language, onNavigate, settings }: AccountingConfigurationViewProps) {
  const [activeTab, setActiveTab] = useState<'chart_of_accounts' | 'tags' | 'tax_base' | 'journals' | 'default_accounts'>('chart_of_accounts');

  return (
    <div className="flex flex-col h-full bg-white relative">
      {/* Header Tabs */}
      <div className="flex gap-4 border-b-2 border-[#141414]/10 mb-6 px-6 sticky top-0 bg-white z-10 w-full pt-6 md:pt-14 whitespace-nowrap overflow-x-auto hidden-scrollbar">
        {(['chart_of_accounts', 'tags', 'tax_base', 'journals', 'default_accounts'] as const).map(tab => {
            let label = tab.replace(/_/g, ' ');
            if (tab === 'journals') label = 'Journals';
            return (
          <button
            key={tab}
            onClick={() => setActiveTab(tab)}
            className={cn(
              "px-6 py-3 font-bold text-sm uppercase tracking-widest transition-all border-b-4",
              activeTab === tab 
                ? "border-[#141414] text-[#141414]" 
                : "border-transparent text-[#141414]/40 hover:text-[#141414]/60"
            )}
          >
            {label}
          </button>
        )})}
      </div>

      <div className="flex-1 overflow-auto bg-white">
        {activeTab === 'chart_of_accounts' && <ChartOfAccountsView orgId={orgId} language={language} onNavigate={onNavigate} />}
        {activeTab === 'tags' && <TagsView orgId={orgId} language={language as 'en' | 'ar'} />}
        {activeTab === 'tax_base' && <TaxBaseView orgId={orgId} language={language as 'en' | 'ar'} theme={settings?.theme || 'light'} />}
        {activeTab === 'journals' && <JournalsSetupView orgId={orgId} language={language} />}
        {activeTab === 'default_accounts' && <DefaultAccountsView orgId={orgId} language={language} />}
      </div>
    </div>
  );
}
